import { deleteClauseById } from "@/api";
import { DestructiveDialog } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog";
import { DestructiveDialogProps } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog.types";
import { Delete } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useQueryClient } from "@tanstack/react-query";
import { useDialogs } from "@toolpad/core";

interface IProps {
    /**
     * The ID of the clause to delete.
     */
    clauseId: number;
}

/**
 * A button that, when clicked, opens a dialog to confirm deletion of a clause.
 */
export const DeleteClauseButton = ({ clauseId }: IProps) => {
    const dialogs = useDialogs();
    const queryClient = useQueryClient();

    const dialogProps: DestructiveDialogProps = {
        itemId: clauseId,
        subject: "clause",
        mutationFn: deleteClauseById,
        onSucceeded: () => {
            queryClient.invalidateQueries({
                queryKey: ["admin-clauses"],
            });
        },
    };

    const handleDelete = async () => {
        await dialogs.open(DestructiveDialog, dialogProps);
    };

    return (
        <GridActionsCellItem
            icon={
                <Tooltip title="Delete Clause">
                    <Delete />
                </Tooltip>
            }
            label="Delete"
            onClick={handleDelete}
        />
    );
};
